import { ShadowBox } from "../../UI/ShadowBox/ShadowBox";
import { Bullets } from "../Bullets/Bullets";
import styles from "./References.module.scss";

export const References = ({ title, slug }) => (
  <ShadowBox className={styles.root}>
    <h2>{title}</h2>
    <Bullets text="Add list" slug={`${slug}.bullets`} type="ol" />
  </ShadowBox>
);
